"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredFieldValidationError = void 0;
var RequiredFieldValidationError;
(function (RequiredFieldValidationError) {
    RequiredFieldValidationError[RequiredFieldValidationError["None"] = 0] = "None";
    RequiredFieldValidationError[RequiredFieldValidationError["EmptyValueNotAllowed"] = 1] = "EmptyValueNotAllowed";
    RequiredFieldValidationError[RequiredFieldValidationError["NotValid"] = 2] = "NotValid";
    RequiredFieldValidationError[RequiredFieldValidationError["MiniumUnderRun"] = 3] = "MiniumUnderRun";
    RequiredFieldValidationError[RequiredFieldValidationError["MaximumExceeded"] = 4] = "MaximumExceeded";
    RequiredFieldValidationError[RequiredFieldValidationError["EmailIsNotVerified"] = 5] = "EmailIsNotVerified";
    RequiredFieldValidationError[RequiredFieldValidationError["DocumentIsNotVerified"] = 6] = "DocumentIsNotVerified";
    RequiredFieldValidationError[RequiredFieldValidationError["ClassNotFound"] = 100] = "ClassNotFound";
    RequiredFieldValidationError[RequiredFieldValidationError["PropertyNotFound"] = 101] = "PropertyNotFound";
})(RequiredFieldValidationError = exports.RequiredFieldValidationError || (exports.RequiredFieldValidationError = {}));
